(function () {
  document.addEventListener("DOMContentLoaded", function () {

    function openPreorderModal() {
      const modal = document.getElementById("preorder-modal");
      if (modal) {
        modal.classList.add("active");
      }
    }

    function closePreorderModal() {
      const modal = document.getElementById("preorder-modal");
      if (modal) {
        modal.classList.remove("active");
      }
    }

    // Delegación para soportar AJAX y sections render
    document.addEventListener("click", function (e) {

      const button = e.target.closest("button[type='submit'][name='add']");
      if (!button) return;

      const preorderSpan = button.querySelector(".preorder-add-tocart");

      if (preorderSpan) {
        // Delay pequeño para no interferir con submit
        setTimeout(function () {
          openPreorderModal();
        }, 300);
      }

    });

    // Cierre modal
    document.addEventListener("click", function (e) {
      if (
        e.target.classList.contains("preorder-modal__overlay") ||
        e.target.classList.contains("preorder-modal__btn")
      ) {
        closePreorderModal();
      }
    });

  });
})();